import { BraxSelectOption } from 'design-system';

import { T } from '../utils/i18n';

export type PaymentInterval = 'monthly' | 'yearly';

const paymentInterval: BraxSelectOption<PaymentInterval>[] = [{
    value: 'monthly',
    title: <T label="Pagamento mensal" />,
    icon: 'calendar'
}, {
    title: <T label="Pagamento anual" />,
    value: 'yearly',
    icon: 'calendar'
}];

export default paymentInterval;
